import { useEffect } from 'react'

import type { IframeMessage, ParentMessage } from '../types'

export function usePostMessage(onMessage: (msg: ParentMessage) => void) {
	useEffect(() => {
		const handler = (e: MessageEvent) => {
			if (e.data && typeof e.data === 'object' && 'type' in e.data) {
				onMessage(e.data as ParentMessage)
			}
		}
		window.addEventListener('message', handler)
		return () => window.removeEventListener('message', handler)
	}, [onMessage])
}

export function sendToParent(msg: IframeMessage) {
	window.parent.postMessage(msg, '*')
}
